var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgCalendarCloseLine = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.99967 1.99984V0.666504H4.66634V1.99984H1.99967C1.63149 1.99984 1.33301 2.29832 1.33301 2.6665V13.3332C1.33301 13.7014 1.63149 13.9998 1.99967 13.9998H13.9997C14.3679 13.9998 14.6663 13.7014 14.6663 13.3332V2.6665C14.6663 2.29832 14.3679 1.99984 13.9997 1.99984H11.333V0.666504H9.99967V1.99984H5.99967ZM2.66634 6.6665H13.333V12.6665H2.66634V6.6665ZM2.66634 3.33317H4.66634V3.99984H5.99967V3.33317H9.99967V3.99984H11.333V3.33317H13.333V5.33317H2.66634V3.33317ZM6.58542 7.30944L7.99967 8.7237L9.41381 7.30944L10.3567 8.25217L8.94247 9.66657L10.3566 11.0806L9.41387 12.0234L7.99967 10.6094L6.58537 12.0234L5.64262 11.0806L7.05681 9.66657L5.64258 8.25217L6.58542 7.30944Z",
    fill: "#182534"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCalendarCloseLine, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Calendar-Close-Line.5d8a5691.svg";
export { ForwardRef as ReactComponent };